/** Mirror backend MANAGEABLE_SUBSCRIPTION_STATUSES — subscription update path, not new checkout. */
export const MANAGEABLE_SUBSCRIPTION_STATUSES = [
  'active',
  'trialing',
  'paused',
  'past_due',
  'incomplete',
];

export const hasManageableSubscriptionStatus = (status) => (
  MANAGEABLE_SUBSCRIPTION_STATUSES.includes(status || 'none')
);

/** Prefer activePlan.hasBillingSubscription from API when available. */
export const isBillingLockedForPilot = (activePlan) => {
  if (activePlan?.hasBillingSubscription) {
    return true;
  }
  return hasManageableSubscriptionStatus(activePlan?.subscriptionStatus)
    && Boolean(activePlan?.subscription);
};
